import { Grid } from 'antd'
const { useBreakpoint } = Grid

export default function CheckResponsiveDesktop() {
  const screens = useBreakpoint()
  return screens.md
}
